
const dftLng = 'en';
window.VERSION = dftLng;
(function (window) {
  var max_age = 31536000;
  var key, result;
  var map = {
    zh: 'zh',
    en: 'en',
    ko: 'ko',
    jp: 'jp',
    ja: 'jp',
  };
  var cleanUrl = false;
  if ((result = /lang(?:uage)?=(\w+)/.exec(window.location.search))) {
    key = map[result[1]];
    cleanUrl = true; // 如果从 url 上带有 language 参数, 则应该清除这个参数
  } else if (
    (result = /(?:^|\s)saas_intl=(\w+)(?:;|$)/.exec(document.cookie))
  ) {
    key = map[result[1]];
  } else {
    key = 'en';
  }
  if (key) {
    window.VERSION = key;
    max_age = 86400;
  }

  var expiresTimestamp = new Date(2153717523864).toUTCString();


  // saas_intl 是 独立站的 cookie，日语用ja
  var saasIntlMap = {
    zh: 'zh',
    en: 'en',
    ko: 'ko',
    jp: 'ja',
  };
  document.cookie =
    'saas_intl=' +
    saasIntlMap[window.VERSION] +
    '; expires=' +
    expiresTimestamp +
    ' ;domain=' +
    '.trtc.io' +
    '; path=/; SameSite=None; Secure';

  // language 是 tea用到的cookie，日语用 jp
  document.cookie =
    'language=' +
    window.VERSION +
    '; expires=' +
    expiresTimestamp +
    ' ;domain=' +
    '.trtc.io' +
    '; path=/; SameSite=None; Secure';
  
  document.documentElement.lang = saasIntlMap[window.VERSION] || 'en'
  if (cleanUrl) {
    // location.search = location.search.replace(/&?lang(uage)?=\w+/, '');
  }
})(window);
